import styled, { css } from 'styled-components';

import { withAuthRedirect } from '../hocs';
import { Panel, PanelHeader, PanelContent } from '../atoms';
import { MerchantLinksList } from '../organisms';

const commitId = process.env.REACT_APP_COMMIT_ID ?? 'unknown';

const VersionInfo = styled.div(
  ({ theme }) => css`
    position: absolute;
    bottom: 0;
    padding: 30px 4px;
  `
);

const MerchantUsefulLinksPage = () => (
  <Panel>
    <PanelHeader>
      <h1>Useful Links</h1>
    </PanelHeader>
    <PanelContent>
      <MerchantLinksList />
      <VersionInfo>Build version: {commitId}</VersionInfo>
    </PanelContent>
  </Panel>
);

const SecureMerchantUsefulLinksPage = withAuthRedirect(MerchantUsefulLinksPage);
export { SecureMerchantUsefulLinksPage as MerchantUsefulLinksPage };
